module.exports = __webpack_public_path__ + "static/8152-c75d8bef815d2f4fc7625eca42485c3f.jpg";